import { openmbApi } from 'redux/services/open_mb'

import { AppLoader } from 'components/AppLoader'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'

import { OpenMB } from 'models/open_mb'

import { formatDate } from 'shared/libs'
import { DocumentsList } from 'shared/ui'

import styles from './Details.module.scss'

interface DetailsProps {
  id: OpenMB['id']
  onClose: () => void
}

export const Details = ({ id, onClose }: DetailsProps) => {
  const { data, isLoading, isSuccess, error } =
    openmbApi.useGetOpenMBByIdQuery(id)

  function renderValue(label: string, key: keyof OpenMB) {
    if (data?.[key]) {
      return (
        <div className={styles.item}>
          <div className={styles.itemName}>{label}</div>
          <div className={styles.itemText}>{data?.[key]}</div>
        </div>
      )
    }
    return null
  }

  if (isLoading) return <AppLoader />

  if (isSuccess) {
    return (
      <>
        <AppModalHeader onClose={onClose} title={id} />
        <div className={styles.container}>
          {renderValue('JIRA', 'jira_key')}
          <div className={styles.item}>
            <div className={styles.itemName}>Дата создания</div>
            <div className={styles.itemText}>{formatDate(data.created_at)}</div>
          </div>
          {renderValue('Наименование предприятия', 'name')}
          {renderValue('РКО', 'rko_account')}
          {renderValue('Транзитный счет 1', 'transit_1')}
          {renderValue('Транзитный счет 2', 'transit_2')}
          {renderValue('Доработки по заявке (Вопрос)', 'revision_application')}
          {renderValue('Ответ', 'customfield_14725')}

          <br />

          {data.consultant ? (
            <>
              <div className={styles.item}>
                <div className={styles.itemName}>Консультант</div>
                <div className={styles.itemText}>
                  <strong>ФИО:</strong>
                  <span>{data.consultant.full_name}</span>
                </div>
                <div className={styles.itemText}>
                  <strong>Тип подразделения:</strong>
                  <span>{data.consultant.get_type_division_display}</span>
                </div>
                <div className={styles.itemText}>
                  <strong></strong>
                  <span>{data.consultant.main_branch}</span>
                </div>
                <div className={styles.itemText}>
                  <strong></strong>
                  <span>{data.consultant.branches}</span>
                </div>
              </div>
              <br />
            </>
          ) : null}

          <DocumentsList list={data.other_documents} />
        </div>
      </>
    )
  }

  return <code>{JSON.stringify(error)}</code>
}
